import { GITLEAKS_RULES_BY_ID } from '../../data/gitleaks-rules';
import { GITLEAKS_GENERIC_API_KEY_RULE, PRIVATE_KEY_REGEX_FNV1A, SECRET_DETECTOR_PAIRS, } from '../../data/alert-risk-text';
import { clientDisplayName, fnv1a, fillRiskTemplate, partsOf, present, riskCopy, } from './common';
/**
 * The detector variant from exact (engine, ruleId) identity, first match wins.
 * Without engine and rule id (flag off, or older rows) the detector is unknown.
 */
export function selectSecretVariant(alert) {
    const engine = present(alert.engine);
    const ruleId = present(alert.ruleId);
    if (engine == null || ruleId == null) {
        return 'C0';
    }
    const pair = SECRET_DETECTOR_PAIRS.find(p => p.engine === engine && p.ruleId === ruleId);
    if (pair != null)
        return pair.variant;
    // Row 55: exactly the backend default; other private-key regexes (hook,
    // agent, org rules) are unverified and get C15 or C0.
    if (engine === 'regex' && fnv1a(ruleId) === PRIVATE_KEY_REGEX_FNV1A) {
        return 'C13';
    }
    if (engine === 'gitleaks') {
        if (ruleId === GITLEAKS_GENERIC_API_KEY_RULE)
            return 'C14a';
        return GITLEAKS_RULES_BY_ID.has(ruleId) ? 'C14b' : 'C0';
    }
    return present(alert.ruleName) == null ? 'C0' : 'C15';
}
/**
 * {where}, first match wins (column T). Post-tool events use step 5 until V2
 * confirms which producers send them; C0 uses only the ungated steps 1, 2, 5.
 */
export function secretWhere(alert, useEvent) {
    const client = clientDisplayName(alert.clientType);
    if (alert.description.endsWith(' in prompt')) {
        return client == null ? 'in a prompt' : `in a prompt entered in ${client}`;
    }
    if (alert.description.endsWith(' in AI chat')) {
        return client == null
            ? 'in an AI response'
            : `in an AI response in ${client}`;
    }
    if (useEvent && alert.eventKind === 'pre') {
        const toolName = present(alert.toolName);
        const tool = toolName == null ? 'a tool call' : `the tool "${toolName}"`;
        return `in content Kirin checked for ${tool}${client == null ? '' : `, requested in ${client}`}`;
    }
    return client == null
        ? 'in content handled by an AI coding tool'
        : `in content handled by ${client}`;
}
/**
 * customPatterns::secret-leakage. A detector not on the exact pair list (the
 * hook and agent regexes until V3) gets C15 or C0, never a named format.
 */
export function resolveSecretFormat(alert) {
    const variant = selectSecretVariant(alert);
    const copy = riskCopy(`customPatterns::secret-leakage#${variant}`);
    return partsOf(copy, fillRiskTemplate(copy.whatHappened, {
        where: secretWhere(alert, variant !== 'C0'),
        ruleName: present(alert.ruleName),
    }), copy.whyItMatters);
}
//# sourceMappingURL=secrets.js.map